
import { useAuth } from "@/components/AuthProvider";
import { useNavigate } from "react-router-dom";

export type PremiumFeature = 'elements' | 'precision_mode' | 'second_opinion' | 'drawing_history';

export function usePremiumFeatures() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const isAuthenticated = !!user;

  const handlePremiumFeature = (feature: PremiumFeature) => {
    if (!isAuthenticated) {
      const overlay = document.createElement('div');
      overlay.className = 'fixed inset-0 z-[42] transform translate-y-full';
      
      // Match the banner's gradient but with transparency
      overlay.style.background = 'linear-gradient(to bottom, rgba(229, 222, 255, 0.7), rgba(255, 255, 255, 0.7))';
      overlay.style.transition = 'transform 300ms ease-out';
      
      // Create container for arrow and text
      const container = document.createElement('div');
      container.className = 'absolute left-1/2 top-16 -translate-x-1/2 flex flex-col items-center transform translate-y-full transition-transform duration-300';
      
      // Add arrow pointing up
      const arrow = document.createElement('div');
      arrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-up"><path d="m5 12 7-7 7 7"/><path d="M12 19V5"/></svg>`;
      arrow.className = 'text-purple-500';

      // Add text below arrow
      const text = document.createElement('div');
      text.textContent = 'Account Required';
      text.className = 'mt-2 text-sm font-medium text-gray-700';
      
      container.appendChild(arrow);
      container.appendChild(text);
      overlay.appendChild(container);
      document.body.appendChild(overlay);

      // Trigger the slide-up animations
      requestAnimationFrame(() => {
        overlay.style.transform = 'translateY(0)';
        container.style.transform = 'translate(-50%, 0)';
      });

      // Remove overlay when navigating away
      const handleNavigation = () => {
        overlay.style.transform = 'translateY(100%)';
        container.style.transform = 'translate(-50%, 100%)';
        setTimeout(() => {
          document.body.removeChild(overlay);
        }, 300);
      };

      // Clean up after navigation or timeout
      setTimeout(handleNavigation, 2000);

      return false;
    }
    return true;
  };

  return {
    isAuthenticated,
    handlePremiumFeature
  };
}
